import {ScrollWrap} from "../../styles/CommonStyles";
import {
  Row,
  Column,
  Flex,
  FirstPart,
  Favorite,
} from "../../styles/PairBoxStyles";
import { formatNumber } from "../../utils/common"
import { useMainContext } from "../../contexts/main"
import {Fragment, useRef} from "react";


const PairTable = ({ pairs, onStarredChange }) => {

  const starRef = useRef([])
  const { market, setMarket } = useMainContext()

  const onPairClicked = (e, idx, pair) => {
    if (!starRef?.current[idx]?.contains(e?.target)) {
      if (market?.coin !== pair.coin || market?.pair !== pair.pair) {
        setMarket({ coin: pair.coin, pair: pair.pair })
      }
    }
  }


  return (
      <ScrollWrap height="calc(100% - 120px)" style={{  maxHeight: '380px' }}>
          {pairs?.map((pair, index) => (
              <Fragment key={index}>
                {pair?.pair && (
                    <Row key={pair.price} onClick={(e) => onPairClicked(e, index, pair)}>
                      <Column index={0}>
                        <Flex>
                          <Flex
                              ref={el => starRef.current[index] = el}
                          >
                            <Favorite
                                onClick={() => onStarredChange(pair)}
                                active={pair.starred}
                            />
                          </Flex>
                          <Flex>
                            <FirstPart>{pair?.coin?.toUpperCase()}</FirstPart>/
                            {pair?.pair?.toUpperCase()}
                          </Flex>
                        </Flex>
                      </Column>
                      <Column index={1} definedColor={pair.color}>
                        {formatNumber(pair.price, { type: pair?.pair })}
                      </Column>
                      <Column
                          index={2}
                          definedColor={pair._24change > 0 ? "green" : pair._24change < 0 ? "red" : null}
                      >
                        {
                          !pair._24change ?
                              '-'
                              :
                              parseFloat(pair._24change).toFixed(2)
                        }
                      </Column>
                    </Row>
                )}
              </Fragment>
          ))}
      </ScrollWrap>
  );
};


export default PairTable;
